export const heroStats = [
  { id: 's1', label: '今日更新', value: '128', unit: '条' },
  { id: 's2', label: '收录合集', value: '3,640', unit: '套' },
  { id: 's3', label: '打包资源', value: '926', unit: '份' },
  { id: 's4', label: '在逛的人', value: '52.3', unit: '万' },
];

export const tickerItems = [
  '【速报】爱黑料网合集 · 本周新增 12 套图文集，已同步至资源库',
  '【打包上新】927 号打包资源开放下载，含高清原图与目录索引',
  '【热帖】深夜吃瓜区今日新增 340 条讨论，快去占楼',
  '【提醒】爱黑料网精选已按时间线重排，翻找更快',
  '【公告】资源库新增「按更新倒序」浏览方式，省去翻找时间',
];

export const quickNews = [
  {
    id: 'n1',
    time: '10:42',
    tag: '速报',
    title: '爱黑料网合集新增 12 套图文集，已全部并入资源库',
    summary:
      '本轮更新集中在深夜话题区，素材统一做了去重与整理，点开即可按时间线连续浏览，不用再一页页翻找。',
    heat: 8421,
    comments: 316,
    thumb: 'https://readdy.ai/api/search-image?query=warm%20editorial%20collage%20of%20blurred%20magazine%20photos%20with%20torn%20paper%20layers%2C%20muted%20terracotta%20and%20amber%20palette%2C%20soft%20studio%20lighting%2C%20stylized%20abstract%20gossip%20board%2C%20no%20readable%20text%2C%20flat%20top-down%20composition&width=480&height=360&seq=ahh-feed-01&orientation=landscape',
  },
  {
    id: 'n2',
    time: '09:58',
    tag: '打包',
    title: '927 号打包资源开放，附目录索引与高清原图',
    summary: '整合近一周热度最高的图文集，压缩包内含分类目录，解压后即可按编号快速定位想看的那一套。',
    heat: 6210,
    comments: 208,
    thumb: 'https://readdy.ai/api/search-image?query=stack%20of%20folders%20and%20printed%20photo%20sheets%20on%20a%20warm%20paper%20table%2C%20muted%20terracotta%20and%20amber%20tone%2C%20soft%20diffused%20daylight%2C%20editorial%20still%20life%2C%20clean%20minimal%20background%2C%20no%20readable%20text&width=480&height=360&seq=ahh-feed-02&orientation=landscape',
  },
  {
    id: 'n3',
    time: '09:21',
    tag: '热帖',
    title: '「深夜吃瓜区」今日楼数破 340，回帖区比正文还精彩',
    summary: '有人整理时间线，有人补充前情提要，社区把零散素材串成了一条完整脉络。',
    heat: 5890,
    comments: 512,
    thumb: '',
  },
  {
    id: 'n4',
    time: '08:47',
    tag: '精选',
    title: '爱黑料网精选换版：按更新时间倒序，翻找更省事',
    summary: '首页精选模块改为时间线排布，最新入库的图文集置顶，旧内容按周归档，不再需要逐页翻。',
    heat: 4022,
    comments: 96,
    thumb: 'https://readdy.ai/api/search-image?query=vertical%20timeline%20of%20paper%20cards%20pinned%20to%20a%20warm%20cork%20board%2C%20muted%20terracotta%20and%20cream%20palette%2C%20soft%20shadowless%20lighting%2C%20stylized%20editorial%20infographic%20texture%2C%20no%20readable%20text&width=480&height=360&seq=ahh-feed-04&orientation=landscape',
  },
  {
    id: 'n5',
    time: '08:05',
    tag: '速报',
    title: '资源库夜间维护完成，历史合集检索恢复正常',
    summary: '本轮维护重排了标签层级，同一个关键词现在能同时命中合集、打包与单套图文。',
    heat: 2180,
    comments: 44,
    thumb: '',
  },
  {
    id: 'n6',
    time: '07:30',
    tag: '公告',
    title: '打包资源清单更新至 926 份，新增小体积精简包',
    summary: '考虑到移动端流量，新增了一批精简压缩包，只保留正片与目录，适合随手存一份。',
    heat: 1960,
    comments: 61,
    thumb: 'https://readdy.ai/api/search-image?query=neat%20archive%20boxes%20and%20small%20labeled%20paper%20slips%20arranged%20on%20a%20warm%20linen%20surface%2C%20muted%20terracotta%20and%20amber%20tones%2C%20soft%20window%20light%2C%20minimal%20editorial%20top-down%20still%20life%2C%20no%20readable%20text&width=480&height=360&seq=ahh-feed-06&orientation=landscape',
  },
];

export const featuredCollections = [
  {
    id: 'c1',
    title: '城市夜归人图文集',
    desc: '把散落在各处的深夜素材按街区归拢，一条线看完整段脉络。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20collage%20of%20night%20city%20photos%20with%20torn%20paper%20edges%2C%20muted%20terracotta%20and%20amber%20palette%2C%20soft%20glow%20lighting%2C%20stylized%20abstract%20magazine%20board%2C%20no%20readable%20text&width=800&height=520&seq=ahh-cover-01&orientation=landscape',
    tags: ['图文集', '时间线'],
    count: 186,
    updated: '10 分钟前',
    hot: true,
  },
  {
    id: 'c2',
    title: '摄影棚外的一百个瞬间',
    desc: '花絮向合集，收录拍摄间隙被忽略的碎片，配图比重很高。',
    cover:
      'https://readdy.ai/api/search-image?query=soft%20studio%20backdrop%20with%20scattered%20photo%20prints%20and%20clips%2C%20muted%20terracotta%20and%20cream%20palette%2C%20gentle%20diffused%20lighting%2C%20stylized%20editorial%20collage%20texture%2C%20no%20readable%20text&width=800&height=520&seq=ahh-cover-02&orientation=landscape',
    tags: ['花絮', '高热度'],
    count: 142,
    updated: '32 分钟前',
    hot: false,
  },
  {
    id: 'c3',
    title: '热议话题时间线存档',
    desc: '一件事的前因后果按分钟排好，新瓜旧瓜放在同一条线上看。',
    cover:
      'https://readdy.ai/api/search-image?query=long%20paper%20timeline%20scroll%20on%20a%20warm%20desk%20with%20small%20paper%20markers%2C%20muted%20terracotta%20and%20amber%20palette%2C%20soft%20natural%20light%2C%20minimal%20editorial%20still%20life%2C%20no%20readable%20text&width=800&height=520&seq=ahh-cover-03&orientation=landscape',
    tags: ['盘点', '存档'],
    count: 98,
    updated: '1 小时前',
    hot: false,
  },
  {
    id: 'c4',
    title: '街拍与幕后混剪集',
    desc: '把街拍、路透和幕后素材混在一起，按场景而不是按日期分组。',
    cover:
      'https://readdy.ai/api/search-image?query=overlapping%20street%20photography%20prints%20and%20film%20strips%20on%20warm%20paper%2C%20muted%20terracotta%20and%20amber%20tones%2C%20soft%20daylight%2C%20stylized%20editorial%20collage%20composition%2C%20no%20readable%20text&width=800&height=520&seq=ahh-cover-04&orientation=landscape',
    tags: ['混剪', '场景'],
    count: 213,
    updated: '2 小时前',
    hot: true,
  },
  {
    id: 'c5',
    title: '后台与彩排实录',
    desc: '偏冷门的一类素材，胜在完整，适合从头顺着看一遍。',
    cover:
      'https://readdy.ai/api/search-image?query=backstage%20passes%20and%20paper%20cue%20cards%20on%20a%20warm%20wooden%20table%2C%20muted%20terracotta%20and%20cream%20palette%2C%20soft%20low%20lighting%2C%20minimal%20editorial%20photography%2C%20no%20readable%20text&width=800&height=520&seq=ahh-cover-05&orientation=landscape',
    tags: ['实录', '完整'],
    count: 74,
    updated: '4 小时前',
    hot: false,
  },
  {
    id: 'c6',
    title: '一周热图精选合辑',
    desc: '每周固定整理一次，把当周出现频率最高的图文重新编排。',
    cover:
      'https://readdy.ai/api/search-image?query=weekly%20grid%20of%20warm%20toned%20photo%20cards%20pinned%20on%20a%20cream%20board%2C%20muted%20terracotta%20and%20amber%20palette%2C%20even%20soft%20lighting%2C%20stylized%20editorial%20layout%20texture%2C%20no%20readable%20text&width=800&height=520&seq=ahh-cover-06&orientation=landscape',
    tags: ['周更', '合辑'],
    count: 305,
    updated: '6 小时前',
    hot: false,
  },
];

export const downloadPacks = [
  { id: 'p1', name: '爱黑料网打包 · 927 号合集包', size: '3.42 GB', format: 'ZIP', items: 186, updated: '今天 09:58', hot: true },
  { id: 'p2', name: '深夜话题线 · 完整存档包', size: '1.18 GB', format: 'ZIP', items: 142, updated: '今天 08:20', hot: false },
  { id: 'p3', name: '街拍混剪精选 · 精简包', size: '486 MB', format: '7Z', items: 213, updated: '昨天 22:11', hot: true },
  { id: 'p4', name: '一周热图 · 第 38 期', size: '742 MB', format: 'ZIP', items: 305, updated: '昨天 18:40', hot: false },
  { id: 'p5', name: '后台实录 · 冷门补全包', size: '1.06 GB', format: 'RAR', items: 74, updated: '前天 20:05', hot: false },
];

export const boardZones = [
  { id: 'z1', name: '深夜吃瓜区', icon: 'ri-moon-clear-line', desc: '夜深了，楼才刚开始盖', posts: '24.6万', today: 340 },
  { id: 'z2', name: '合集速递', icon: 'ri-stack-line', desc: '新入库的图文集在这里排队', posts: '9.8万', today: 128 },
  { id: 'z3', name: '打包下载', icon: 'ri-download-cloud-2-line', desc: '一键取走，附目录索引', posts: '6.2万', today: 92 },
  { id: 'z4', name: '时间线整理', icon: 'ri-git-branch-line', desc: '把零散线索串成一条线', posts: '4.4万', today: 51 },
  { id: 'z5', name: '资源库答疑', icon: 'ri-question-answer-line', desc: '找不到的，来这里问一句', posts: '3.1万', today: 47 },
  { id: 'z6', name: '老帖挖坟', icon: 'ri-history-line', desc: '旧瓜新吃，偶尔更香', posts: '2.7万', today: 33 },
];

export const hotDiscussions = [
  { id: 'd1', title: '整理了一下这条线的时间顺序，欢迎补充', author: '夜行记录员', replies: 216, likes: 1842, tag: '时间线', time: '12 分钟前' },
  { id: 'd2', title: '927 号包我下完了，目录是真的做得细', author: '压缩包收藏家', replies: 132, likes: 964, tag: '打包', time: '35 分钟前' },
  { id: 'd3', title: '有没有人一起把 38 期的图按主题重分一遍', author: '分类强迫症', replies: 98, likes: 731, tag: '协作', time: '1 小时前' },
  { id: 'd4', title: '冷门实录那套建议从头看，别跳着看', author: '慢速浏览者', replies: 76, likes: 588, tag: '心得', time: '2 小时前' },
  { id: 'd5', title: '求问旧帖里那个编号对应的是哪一期', author: '新来的', replies: 64, likes: 210, tag: '答疑', time: '3 小时前' },
];

export const activeUsers = [
  { id: 'u1', name: '夜行记录员', score: 9820, badge: '整理榜', rank: 1 },
  { id: 'u2', name: '压缩包收藏家', score: 8615, badge: '分享榜', rank: 2 },
  { id: 'u3', name: '分类强迫症', score: 7450, badge: '归档榜', rank: 3 },
  { id: 'u4', name: '慢速浏览者', score: 6120, badge: '长评榜', rank: 4 },
];

export const galleryItems = [
  { id: 'g1', title: '午夜街灯下的回眸', category: '街拍', img: 'https://readdy.ai/api/search-image?query=warm%20toned%20street%20photo%20of%20blurred%20city%20lights%20at%20night%2C%20muted%20terracotta%20and%20amber%20palette%2C%20soft%20grain%2C%20stylized%20editorial%20collage%2C%20square%20crop%2C%20no%20readable%20text&width=600&height=600&seq=ahh-gal-01&orientation=squarish' },
  { id: 'g2', title: '后台镜子前的三分钟', category: '幕后', img: 'https://readdy.ai/api/search-image?query=moody%20backstage%20mirror%20scene%20with%20warm%20bulbs%20and%20soft%20fabric%20curtains%2C%20muted%20terracotta%20and%20cream%20palette%2C%20soft%20glow%2C%20stylized%20editorial%20photography%2C%20square%20crop%2C%20no%20readable%20text&width=600&height=600&seq=ahh-gal-02&orientation=squarish' },
  { id: 'g3', title: '被剪掉的那一帧', category: '花絮', img: 'https://readdy.ai/api/search-image?query=scattered%20film%20frames%20and%20paper%20clips%20on%20warm%20paper%2C%20muted%20terracotta%20and%20amber%20tones%2C%20soft%20diffused%20lighting%2C%20stylized%20editorial%20still%20life%2C%20square%20crop%2C%20no%20readable%20text&width=600&height=600&seq=ahh-gal-03&orientation=squarish' },
  { id: 'g4', title: '候场区的长椅', category: '纪实', img: 'https://readdy.ai/api/search-image?query=empty%20wooden%20bench%20in%20a%20warm%20dim%20hallway%20with%20soft%20light%20spill%2C%20muted%20terracotta%20and%20cream%20palette%2C%20cinematic%20grain%2C%20square%20crop%2C%20no%20readable%20text&width=600&height=600&seq=ahh-gal-04&orientation=squarish' },
  { id: 'g5', title: '棚里的清晨六点', category: '幕后', img: 'https://readdy.ai/api/search-image?query=soft%20morning%20light%20through%20studio%20windows%20with%20warm%20paper%20backdrops%2C%20muted%20terracotta%20and%20amber%20palette%2C%20gentle%20haze%2C%20stylized%20editorial%20photography%2C%20square%20crop%2C%20no%20readable%20text&width=600&height=600&seq=ahh-gal-05&orientation=squarish' },
  { id: 'g6', title: '手写场记板特写', category: '花絮', img: 'https://readdy.ai/api/search-image?query=close%20up%20of%20a%20warm%20toned%20clapperboard%20and%20notebook%20on%20a%20wooden%20surface%2C%20muted%20terracotta%20and%20amber%20palette%2C%20soft%20side%20light%2C%20minimal%20editorial%20still%20life%2C%20square%20crop%2C%20no%20readable%20text&width=600&height=600&seq=ahh-gal-06&orientation=squarish' },
  { id: 'g7', title: '散场之后的走廊', category: '纪实', img: 'https://readdy.ai/api/search-image?query=long%20empty%20corridor%20after%20an%20event%20with%20warm%20wall%20lamps%2C%20muted%20terracotta%20and%20cream%20palette%2C%20soft%20evening%20light%2C%20cinematic%20stylized%20photography%2C%20square%20crop%2C%20no%20readable%20text&width=600&height=600&seq=ahh-gal-07&orientation=squarish' },
  { id: 'g8', title: '堆叠的场刊与门票', category: '收藏', img: 'https://readdy.ai/api/search-image?query=stack%20of%20warm%20toned%20program%20booklets%20and%20paper%20tickets%20on%20a%20linen%20surface%2C%20muted%20terracotta%20and%20amber%20palette%2C%20soft%20top%20light%2C%20minimal%20editorial%20flat%20lay%2C%20square%20crop%2C%20no%20readable%20text&width=600&height=600&seq=ahh-gal-08&orientation=squarish' },
];

export const rankingItems = [
  { id: 'r1', rank: 1, title: '爱黑料网合集 · 深夜话题特辑', score: 98200, trend: 'up' },
  { id: 'r2', rank: 2, title: '927 号打包资源 · 完整目录版', score: 86450, trend: 'up' },
  { id: 'r3', rank: 3, title: '一周热图精选 · 第 38 期', score: 74120, trend: 'same' },
  { id: 'r4', rank: 4, title: '街拍与幕后混剪集', score: 61890, trend: 'down' },
  { id: 'r5', rank: 5, title: '热议话题时间线存档', score: 52340, trend: 'up' },
  { id: 'r6', rank: 6, title: '后台与彩排实录补全包', score: 41960, trend: 'same' },
];